/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "redux/store";
import { IAddTravelOrderTypes, IInvoice } from "shared/interface/types";

const initialState: { TravelOrder: IAddTravelOrderTypes; Invoice: IInvoice } = {
  TravelOrder: {
    id: "",
    customerDetailId: "",
    name: "",
    travelPlanId: null,
    planName: "",
    productName: "",
    cartId: "",
    lineOfBussiness: {
      id: null,
      name: ""
    },
    takafulProvider: {
      id: "",
      companyName: ""
    },
    paymentFrequency: {
      id: null,
      name: ""
    },
    planType: {
      id: null,
      name: ""
    }
  },
  Invoice: {
    id: "",
    dueDate: "",
    amount: "",
    currencySymbol: "",
    paidAt: "",
    currencyId: 0,
    tax: "",
    createdById: "",
    updatedById: "",
    createdAt: "",
    updatedAt: "",
    activityFkId: "",
    payerUserId: "",
    paymentStatusId: 0,
    pickupAddress: "",
    activity: {
      id: 0,
      value: ""
    },
    type: {
      id: 0,
      value: ""
    },
    paymentStatus: {
      id: 0,
      key: "",
      value: ""
    },
    paymentMode: {
      id: 0,
      value: ""
    },
    paymentMethod: {
      id: 0,
      value: ""
    },
    currency: {
      id: 0,
      name: "",
      code: "",
      symbol: ""
    },
    totalContributionValue: "",
    amountValue: "",
    updatedBy: {
      id: 0,
      name: ""
    },
    payer: {
      id: "",
      contactNumber: "",
      name: "",
      isActive: true,
      email: "",
      profileImage: "",
      userType: {
        id: 0,
        key: ""
      }
    }
  }
};

const travelOrderSlice = createSlice({
  name: "travelOrder",
  initialState,
  reducers: {
    AddTravelOrder: (state, action) => {
      state.TravelOrder = action.payload;
    },
    AddOrderInvoice: (state, action) => {
      state.Invoice = action.payload;
    },
    DeleteTravelOrder: state => {
      state.TravelOrder = initialState.TravelOrder;
    }
  }
});

export const { AddTravelOrder, AddOrderInvoice, DeleteTravelOrder } = travelOrderSlice.actions;
export default travelOrderSlice.reducer;

export const getTravelOrder = (state: RootState) => state.travelOrder;
export const getInvoice = (state: RootState) => state.travelOrder;
